import React from "react";
import { Link } from "react-router-dom";
import { Feed } from "../../components/Feed";
import { Layout } from "../../Layout";
import { ArrowLeft } from "react-feather";

export function NewFeed() {
  return (
    <Layout>
      <div className="container  max-w-3xl py-10 mx-auto">
        <>
          <div className="flex items-center gap-4 mb-8">
            <Link to="/feeds" className="btn btn-ghost btn-circle">
              <ArrowLeft />
            </Link>
            <div className="prose">
              <h1 className="">Feed Details</h1>
            </div>
          </div>

          <Feed isNew />
        </>
      </div>
    </Layout>
  );
}
